<template>
    <div>
      <unsubscribe-result-component></unsubscribe-result-component>
    </div>
</template>

<script>

import UnsubscribeResultComponent from "../../components/auth/UnsubscribeResultComponent";
export default {
    name: "UnsubscribeResult",
    mixins: [],
    components: {
      UnsubscribeResultComponent

    },
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {}
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>